"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("./birds/index.js"));
var _index2 = _interopRequireDefault(require("./geometric/index.js"));
var _index3 = _interopRequireDefault(require("./default/index.js"));
var _index4 = _interopRequireDefault(require("./upload/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var builtInLayouts = [_index3["default"], _index["default"], _index2["default"]];
var appLayouts = function () {
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/assignment\/deployment\/layouts\/index\.js$/);
  if (context.keys().length > 0) {
    var filematches = context(context.keys()[0]);
    return filematches["default"] || filematches;
  }
  return [];
}();
var _default = [].concat(builtInLayouts, _toConsumableArray(appLayouts), [_index4["default"]]);
exports["default"] = _default;